const sanitizeNamePart = (value) =>
  (value || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "")

const PP_ALIASES = { authorize: "authorize.net" }

export const generateInviteEmail = ({ businessAccount, pp }) => {
  const baName = sanitizeNamePart(businessAccount?.name)
  const baId = businessAccount?.id
  const normalizedPp = PP_ALIASES[(pp || "").toString().toLowerCase()] || pp
  const ppName = sanitizeNamePart(normalizedPp)

  if (!baName || !baId || !ppName) return null

  return `cr-${baName}_${ppName}_team_${baId}@chargeback.io`
}
